import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  text-align: center;
  padding: 1rem;
  margin: 0;
  font-weight: 600;
  color: ${props => props.theme.colors.white};

  > h1 {
    font-size: 50px;
    margin-bottom: 1rem;
    user-select: none;
    color: ${props => props.theme.colors.white};
  }
`;

export const NotTasks = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 0.5rem;
  margin-top: 1rem;
  padding: 0;

  > header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;

    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      background: ${props => props.theme.cards.tertiary};
      border-radius: 50%;
      padding: 1rem;

      > svg {
        color: ${props => props.theme.colors.primary};
      }
    }

    > h5 {
      color: ${props => props.theme.colors.white};
      font-size: 1rem;
    }
  }

  > main {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;

    > p {
      color: ${props => props.theme.colors.muted};
      font-size: .75rem;
    }
  }
`;